const navbarToggler = document.querySelector(".navbar-toggler");
navbarToggler.addEventListener("click", () =>
  document.querySelector("html").classList.toggle("navbar-open")
);

window.addEventListener("DOMContentLoaded", function () {
  var anchors = document.querySelectorAll(".page__sidebar ul.nav .nav-link");
  var current = window.location.href;

  for (var i = 0; i < anchors.length; i++) {
    if (anchors[i].href == current) {
      anchors[i].classList.add("current-page");
    }
  }
});


let dropdowns = document.querySelectorAll('.dropdown-toggle-inner');
dropdowns.forEach((dd) => {
  dd.addEventListener('click', function (e) {
    var el = this.nextElementSibling;
    el.style.display = el.style.display === 'block' ? 'none' : 'block';
    e.stopPropagation(); // Prevent the click event from propagating further
  });
});

// Event listener for clicks outside of the dropdown
document.addEventListener('click', function (e) {
  dropdowns.forEach((dd) => {
    var el = dd.nextElementSibling;
    if (el.style.display === 'block') {
      el.style.display = 'none';
    }
  });
});


